import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

/**
 * @param {{ skillMapId: string, assignments: Array<{ id: string, writeId?: string }> }} args
 *   Each assignment's writeId as last read, so a record re-assigned since is kept
 */
export const removeScheduleAssignments = api(async function removeScheduleAssignments({ skillMapId, assignments }) {
    return mutate(
        gql`
            mutation RemoveScheduleAssignments($skillMapId: String!, $assignments: [ScheduleAssignmentRefInput!]!) {
                removeScheduleAssignments(skillMapId: $skillMapId, assignments: $assignments)
            }
        `,
        { skillMapId, assignments },
        { returns: "removeScheduleAssignments" }
    )
})
